import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const Patrons = () => { 
  return (
    <>
      <div className="breadcrumb">
        <h2>Patron of our School</h2>
        <ul>
          <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
          <li>|</li> <li>School</li>
          <li>|</li>
          <li>Patron of our School</li>
        </ul>
      </div>
      <div className="inner_page">
        <div className="container">
            <div className="row">
                <div className="col-md-4">
                   <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/patronsSchool1.jpg" alt="st francis school, Amritsar" className="img-fluid" /></LazyLoad>
                </div>
                <div className="col-md-8"> 
                    <h3 className="heading">Patron of our School</h3>
                    <p>St. Francis of Assisi abandoned luxurious life and devoted life to Christianity after reportedly hearing the voice of God, who commanded him to rebuild the Christian Church and to live in poverty. He is the Patron Saint for ecologists.</p>
                    <h4>Synopsis</h4>
                    <p> St. Francis of Assisi, <b>born in Italy in 1181</b>, was a Catholic friar and preacher who founded the Franciscan Order. He is known for his love for animals and nature and is the patron saint of ecology. He is also a symbol of humility, simplicity, and compassion. Many schools around the world have adopted him as their patron saint. </p>
                    <p>Consequently, he abandoned his life of luxury and became a devotee of the faith, his reputation spreading all over the Christian world. Later in life, Francis reportedly received a vision that left him with the stigmata of Christ—marks resembling the wounds Jesus Christ suffered when he was crucified—making Francis the first person to receive such holy wounds. He was canonized as a saint on<span> July 16, 1228. </span>Today, St. Francis of Assisi has had a lasting resonance with millions of followers across the globe.</p>
                </div> 
                <div className="col-lg-12 text-center">
                <h3 className="heading">Prayer for Peace</h3>
                <p> "Lord, make me an instrument of your peace: <br/>
                Where there is hatred, let me sow love; <br/>
                Where there is injury, pardon; <br/>
                Where there is doubt, faith; <br/>
                Where there is despair, hope; <br/>
                Where there is darkness, light; <br/>
                Where there is sadness, joy; <br/>
                O Divine Master, <br/>
                Grant that I may not so much seek <br/>
                to be consoled as to console; <br/>
                to be understood as to understand; <br/>
                to be loved as to love; <br/>
                for it is in giving that we receive; <br/>
                it is in pardoning that we are pardoned, <br/>
                and it is in dying that we are born to eternal life." </p>
                </div>
            </div>
        </div>
      </div>
    </>
  )
}

export default Patrons
